import React from 'react'
import { ensureArray } from '../../utils/helper'

import FormatCurrency from '../../components/elements/FormatCurrency'

import IconCheck from '../../assets/icons/IconCheck'
import IconClose from '../../assets/icons/IconClose'
import IconRefresh from '../../assets/icons/IconRefresh'
import { getDisplayFoodName } from '../../utils'

const ICON_STATE = [IconRefresh, IconCheck]

const FoodInCartSubmitted = ({ food, orderState }) => {
    const { additionFoods, amount, note, price } = food

    let iconShow = IconClose
    if (orderState !== undefined) {
        iconShow = ICON_STATE[orderState]
    }

    return (
        <div className="food-desk-added-box">
            <div className="food-desk-added">
                <div className="info">
                    <div className="name">{getDisplayFoodName(food)}</div>
                </div>

                <div className="change-amount">
                    <div className="amount">{amount}</div>
                </div>

                <div className="btn-edit" />

                <div className="money">
                    <FormatCurrency amount={price} />
                </div>

                <div className="btn-delete" />
            </div>

            {additionFoods && additionFoods.length && (
                <div className="beilage-added">
                    {[
                        ...ensureArray(additionFoods),
                        { name: note },
                    ].filter(beilage => !!beilage.name).map(
                        (beilage, index) => (
                            <div className="flex-between" key={index}>
                                <span>
                                    {beilage.name}
                                </span>
                                {!!beilage.price && <FormatCurrency amount={beilage.price * amount} />}
                            </div>
                        ))}
                </div>
            )}
        </div>
    )
}

export default FoodInCartSubmitted
